export default "__VITE_PUBLIC_ASSET__53250594__"